import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { CustomerRegulatoryModel } from 'app/models/customer-regulatory.model';
import { PaymentMethodModel } from 'app/models/payment-method.model';
import { PaymentMethodService } from 'app/services/payment-method.service';

@Component({
    selector: 'app-payment-method-delete',
    templateUrl: './payment-method-delete.component.html',
    styleUrls: ['./payment-method-delete.component.css'],
    standalone: false
})
export class PaymentMethodDeleteComponent extends NexusComponent {
  @Input() public payment_methods_model: Array<PaymentMethodModel>;
  @Input() public payment_method_model: PaymentMethodModel = new PaymentMethodModel();
  @Input() public regulatory_model: CustomerRegulatoryModel;

  public payment_methods_list: Array<PaymentMethodModel> = new Array<PaymentMethodModel>();
  public result_model: NexusFormResultModel = new NexusFormResultModel();
  public un_link_pressed: boolean;
  public success_message:string;

  public get selectedDefaultId(): string {
    if ((this.payment_methods_list?.length ?? 0) <= 0) {return '';}

    return this.payment_methods_list?.find(x => x.default_account)?.id;
  }
  public selectedDefault = false;

  constructor(private router: Router, private payment_method_service: PaymentMethodService) {
    super();
    this.un_link_pressed = false;
  }

  ngOnInit() {
    this.payment_methods_list = this.payment_methods_model?.filter(x=>x.id !== this.payment_method_model.id);
  }


  setDefault(payment_method: PaymentMethodModel) {
        this.StartSpinner();
        this.payment_method_service.SetDefaultPaymentMethod(payment_method.id).subscribe(
            data => {
                this.payment_methods_model = data;
                this.payment_methods_list = this.payment_methods_model?.filter(x=>x.id !== this.payment_method_model.id);
                this.success_message = `We've set ****${(payment_method.account_type === 'Checking' ? payment_method.ch_number_mask : payment_method.cc_number_mask)?.slice(-4)} as your new primary payment method!`;

                setTimeout(() => {
                  this.un_link_pressed = false;
                  this.selectedDefault = true;
                  this.payment_method_model.default_account = false;
                  if (this.payment_methods_model?.length > 1) {
                    // reset the message after thirty seconds.  This will keep things consistent with the delete component... hopefully...
                    setTimeout(() => this.success_message = '', 1300);
                  }

                  this.StopSpinner();
                }, 1000);
            },
            err => {
                this.StopSpinner();
            });
        return false;
    }

  unLink() {
    this.un_link_pressed = true;

    setTimeout(() => this.un_link_pressed = false, 5000);
  }

  confirmUnLink() {
    this.result_model.Reset();
    this.StartSpinner();

    this.payment_method_service.DeletePaymentMethod(this.payment_method_model.id).subscribe(
      data => {
        this.router.navigate(['/payment-methods']);
        this.StopSpinner();
      },
      err => {
        this.result_model.Error(err);
        this.StopSpinner();
      });
  }

}
